import { IconProps } from "../../utils/global-types/global-types";

const AiSummaryIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_1393_16271)">
        <path
          fillRule="evenodd"
          d="M13.488 1.89a.5.5 0 0 0-.976 0l-.276 1.216a1.5 1.5 0 0 1-1.13 1.13l-1.217.276a.5.5 0 0 0 0 .976l1.217.276a1.5 1.5 0 0 1 1.13 1.13l.276 1.217a.5.5 0 0 0 .976 0l.276-1.217a1.5 1.5 0 0 1 1.13-1.13l1.217-.276a.5.5 0 0 0 0-.976l-1.217-.276a1.5 1.5 0 0 1-1.13-1.13z"
          clipRule="evenodd"
        ></path>
        <path d="M6.5 5a.5.5 0 0 1 .5.5V16a.5.5 0 0 1-1 0V5.5a.5.5 0 0 1 .5-.5M2.5 6.75a.5.5 0 1 0-1 0v8a.5.5 0 0 0 1 0zM4.75 7.75a.5.5 0 1 0-1 0v6a.5.5 0 0 0 1 0zM9.25 7a.5.5 0 1 0-1 0v7.5a.5.5 0 0 0 1 0zM11 8.25a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5"></path>
      </g>
      <defs>
        <clipPath id="clip0_1393_16271">
          <path fill="#fff" d="M1 1h16v16H1z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default AiSummaryIcon;
